export const RESET_TOAST_NOTIFICATION = 'RESET_TOAST_NOTIFICATION';